import _ from "lodash";

export const getPreviewConfig = (element, device) => {
  const DEFAULT_PREVIEW_WIDTH_PERCENT = device === "mobile"
    ? parseInt(element.options["carousel-next-preview-percentage-mobile"]) || 20
    : parseInt(element.options["carousel-next-preview-percentage"]) || 20;

  let showPreview;
  if ((device === "mobile" && element.options.hasOwnProperty("show-next-slide-preview-mobile"))) {
    showPreview = element.options["show-next-slide-preview-mobile"] === "true";
  } else if (element.options.hasOwnProperty("show-next-slide-preview")) {
    showPreview = element.options["show-next-slide-preview"] === "true";
  } else {
    showPreview = false;
  }

  const swipeType = element.options["carousel-swipe-type"];

  if (!showPreview || swipeType === "scrolling") {
    return { enabled: false, previewWidth: 0, mainWidth: 100 };
  }

  const previewWidth = device === "mobile"
    ? parseInt(element.options["carousel-preview-width-mobile"]) || DEFAULT_PREVIEW_WIDTH_PERCENT
    : parseInt(element.options["carousel-preview-width"]) || DEFAULT_PREVIEW_WIDTH_PERCENT;

  return {
    enabled: true,
    previewWidth: previewWidth,
    mainWidth: 100 - previewWidth
  };
};

export const buildCarouselStylesheet = (builder, device, cta, element, variant) => {
    let options = { ...element.options };

    // Get desktop preview configuration (always used for desktop styles)
    const desktopPreviewConfig = getPreviewConfig(element, "desktop");
    const { enabled: showPreview, previewWidth, mainWidth } = desktopPreviewConfig;

    let carouselControlsStyle =
      options["carousel-controls-style"] ||
      variant.options["carousel-controls-style"] ||
      "inside";

    let maxWidthElement = "";
    if (
      options["carousel-max-width-style"] == "custom" &&
      options["carousel-max-width-value"]
    ) {
      if (carouselControlsStyle == "outside") {
        maxWidthElement = `${
          parseInt(options["carousel-max-width-value"]) + 90 // include arrow controls safety space
        }px`;
      } else {
        maxWidthElement = `${options["carousel-max-width-value"]}px`;
      }
    } else if (options["carousel-max-width-style"] == "full") {
      maxWidthElement = "100%";
    }

    let maxWidthSlideWrapper = "";
    if (
      options["carousel-max-width-style"] == "custom" &&
      options["carousel-max-width-value"]
    ) {
      maxWidthSlideWrapper = `${options["carousel-max-width-value"]}px`;
    } else if (options["carousel-max-width-style"] == "full") {
      maxWidthSlideWrapper = "100%";
    }

    let carouselHeight;
    if (
      options["carousel-height-style"] == "custom" &&
      options["carousel-height-value"]
    ) {
      carouselHeight = `${options["carousel-height-value"]}px !important`;
    }

    let carouselBackgroundColor =
      options["carousel-background-color"] || undefined;

    let carouselArrowControlsColor =
      options["carousel-arrow-controls-color"] || undefined;

    let carouselShowArrowBackground = options["carousel-arrow-show-background"] || variant.options["carousel-arrow-show-background"] || "true";

    let carouselArrowBackgroundColor = options["carousel-arrow-background-color"] || variant.options["carousel-arrow-background-color"] || "rgba(255, 255, 255, 0.7)";

    let carouselArrowBorderStyle =
      options["carousel-arrow-border-style"] ||
      variant.options["carousel-arrow-border-style"] || "solid";

    let carouselArrowBorderColor =
      options["carousel-arrow-border-color"] ||
      variant.options["carousel-arrow-border-color"] ||
      carouselArrowControlsColor ||
      variant.options["carousel-arrow-controls-color"] || undefined;

    // Arrow border radius
    let arrowBorderRadiusOption =
      options["carousel-arrow-border-radius"] ||
      variant.options["carousel-arrow-border-radius"] || "cf-fully-rounded";

    let carouselArrowBorderRadius = "";
    if (arrowBorderRadiusOption == "cf-not-rounded") {
      carouselArrowBorderRadius = "0px";
    } else if (arrowBorderRadiusOption == "cf-slightly-rounded") {
      carouselArrowBorderRadius = "4px";
    } else if (arrowBorderRadiusOption == "cf-fully-rounded") {
      carouselArrowBorderRadius = "50%";
    } else if (arrowBorderRadiusOption == "custom") {
      carouselArrowBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          const elementValue = options["carousel-arrow-border-radius-" + side];
          const variantValue = variant.options["carousel-arrow-border-radius-" + side];
          carouselArrowBorderRadius += `${
            _.isNil(elementValue) == false
              ? elementValue
              : _.isNil(variantValue) == false
              ? variantValue
              : "50"
          }% `;
        }
      );
    }

    // Helper function to get border width for a side with fallbacks
    const getArrowBorderWidth = (side) => {
      return options[`carousel-arrow-border-width-${side}`] ||
        options["carousel-arrow-border-width"] ||
        variant.options[`carousel-arrow-border-width-${side}`] ||
        variant.options["carousel-arrow-border-width"] ||
        "1";
    };

    let carouselIndicatorControlsColor =
      options["carousel-indicator-controls-color"] || undefined;

    let carouselIndicatorSize = options["carousel-indicator-size"] || undefined;

    let carouselArrowSize =
      options["carousel-arrow-size"] || variant.options["carousel-arrow-size"];

    let carouselIndicatorBorderRadius = "";
    if (options["carousel-indicator-border-radius"] == "cf-not-rounded") {
      carouselIndicatorBorderRadius = "0px";
    }
    if (options["carousel-indicator-border-radius"] == "cf-slightly-rounded") {
      carouselIndicatorBorderRadius = "4px";
    }
    if (options["carousel-indicator-border-radius"] == "cf-fully-rounded") {
      carouselIndicatorBorderRadius = "100px";
    }
    if (options["carousel-indicator-border-radius"] == "custom") {
      carouselIndicatorBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          carouselIndicatorBorderRadius += `${
            _.isNil(options["carousel-indicator-border-radius-" + side]) ==
            false
              ? options["carousel-indicator-border-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let swipeType = element.options["carousel-swipe-type"];
    let carouselHideArrowControls = element.options["carousel-hide-arrow-controls"] === "true" && swipeType !== "scrolling"
      ? "true"
      : "false"

    // prettier-ignore
    let desktopStyles =
      `#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element {
        ${maxWidthElement ? `max-width: ${maxWidthElement};` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-item > .cf-section {
        overflow: hidden;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-item {
        overflow: hidden;
        ${element.options["carousel-slides-per-view"]
          ? `flex: 0 0 ${(showPreview ? mainWidth : 100) / parseInt(element.options["carousel-slides-per-view"])}% !important;`
          : showPreview ? `flex: 0 0 ${mainWidth}% !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-carousel-item {
        ${carouselHeight ? `height: ${carouselHeight};` : ''}
        ${carouselBackgroundColor ? `background: ${carouselBackgroundColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-carousel-slide-wrapper {
        ${carouselBackgroundColor ? `background: ${carouselBackgroundColor};` : ''}
        ${maxWidthSlideWrapper ? `max-width: ${maxWidthSlideWrapper};` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-carousel-slide-inside-wrapper {
        ${carouselControlsStyle == "inside" && carouselHideArrowControls !== "true" ? carouselArrowSize > 22 ? `margin: 0px -${((carouselArrowSize - 22) + 47)}px;` : "margin: 0px -47px;" : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-arrow-control {
        ${showPreview ? 'position: relative; z-index: 10;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-arrow-control svg {
        ${carouselArrowSize ? `width: ${parseInt(carouselArrowSize) + 8}px !important;` : 'width: 20px;'}
        ${carouselArrowSize ? `height: ${parseInt(carouselArrowSize) + 8}px !important;` : 'height: 20px;'}
        ${carouselArrowBorderStyle && carouselArrowBorderStyle !== 'none' ? `
          border-style: ${carouselArrowBorderStyle} !important;
          border-left-width: ${getArrowBorderWidth('left')}px !important;
          border-right-width: ${getArrowBorderWidth('right')}px !important;
          border-top-width: ${getArrowBorderWidth('top')}px !important;
          border-bottom-width: ${getArrowBorderWidth('bottom')}px !important;
          border-color: ${carouselArrowBorderColor || 'black'} !important;
        ` : 'border: none !important;'}
        ${carouselArrowControlsColor ? `color: ${carouselArrowControlsColor} !important;` : ''}
        ${carouselShowArrowBackground == "true" ? `background-color: ${carouselArrowBackgroundColor || 'rgba(255, 255, 255, 0.7)'} !important;` : 'background-color: transparent !important;'}
        ${carouselArrowBorderRadius ? `border-radius: ${carouselArrowBorderRadius} !important;` : ''}
        padding: 5px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-arrow-control svg:hover {
        ${options["carousel-arrow-hover-border-color"] || variant.options["carousel-arrow-hover-border-color"] 
          ? `border-color: ${options["carousel-arrow-hover-border-color"] || variant.options["carousel-arrow-hover-border-color"]} !important;` 
          : ''}
        ${options["carousel-arrow-hover-controls-color"] || variant.options["carousel-arrow-hover-controls-color"] 
          ? `color: ${options["carousel-arrow-hover-controls-color"] || variant.options["carousel-arrow-hover-controls-color"]} !important;` 
          : ''}
        ${options["carousel-arrow-hover-background-color"] || variant.options["carousel-arrow-hover-background-color"] 
          ? `background-color: ${options["carousel-arrow-hover-background-color"] || variant.options["carousel-arrow-hover-background-color"]} !important;` 
          : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-arrow-control .svg-inline--fa {
        ${carouselArrowSize ? `font-size: ${carouselArrowSize}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-carousel-indicators {
        ${maxWidthSlideWrapper && carouselControlsStyle == "inside" ? `max-width: ${maxWidthSlideWrapper};` : ''}
        position: relative;
        z-index: 11;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-carousel-indicator {
        ${carouselIndicatorSize ? `width: ${carouselIndicatorSize}px !important;` : ''}
        ${carouselIndicatorSize ? `height: ${carouselIndicatorSize}px !important;` : ''}
        ${carouselIndicatorControlsColor ? `background-color: ${carouselIndicatorControlsColor} !important;` : ''}
        ${carouselIndicatorBorderRadius ? `border-radius: ${carouselIndicatorBorderRadius} !important;` : ''}
      }
      `;

    // INDIVIDUAL SLIDES STYLES
    // prettier-ignore
    Object.values(element.content_toggle_items)
      .filter(
        (tab_item) =>
          tab_item.element_id == element.id && tab_item.toBeDeleted !== true
      )
      .sort((a, b) => a.position - b.position).forEach((carousel) => {
        let carouselIndicatorBackgroundImage = "";
        if (
          carousel.options &&
          carousel.options["indicator-background-image"]
        ) {
          carouselIndicatorBackgroundImage =
            carousel.options["indicator-background-image"];
        }

        desktopStyles += `#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-carousel-indicator[data-position="${carousel.position}"] {
          ${carouselIndicatorBackgroundImage ? `background-image: url("${carouselIndicatorBackgroundImage}") !important; background-size: cover;` : ""}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-carousel-indicator[data-position="${carousel.position}"].active {
          ${options["carousel-indicator-active-border-style"] ? 'border-style: ' + options["carousel-indicator-active-border-style"] + ' !important;' : ''}
          ${options["carousel-indicator-active-border-style"] !== "" && _.isNil(options["carousel-indicator-active-border-width"]) == false ? 'border-width: ' + options["carousel-indicator-active-border-width"] + 'px !important;' : ''}
          ${options["carousel-indicator-active-border-style"] !== "" && _.isNil(options["carousel-indicator-active-border-width-left"]) == false ? 'border-left-width: ' + options["carousel-indicator-active-border-width-left"] + 'px !important;' : _.isNil(options["carousel-indicator-active-border-width"]) == false ? 'border-left-width: ' + options["carousel-indicator-active-border-width"] + 'px !important;' : ''}
          ${options["carousel-indicator-active-border-style"] !== "" && _.isNil(options["carousel-indicator-active-border-width-right"]) == false ? 'border-right-width: ' + options["carousel-indicator-active-border-width-right"] + 'px !important;' : _.isNil(options["carousel-indicator-active-border-width"]) == false ? 'border-right-width: ' + options["carousel-indicator-active-border-width"] + 'px !important;' : ''}
          ${options["carousel-indicator-active-border-style"] !== "" && _.isNil(options["carousel-indicator-active-border-width-top"]) == false ? 'border-top-width: ' + options["carousel-indicator-active-border-width-top"] + 'px !important;' : _.isNil(options["carousel-indicator-active-border-width"]) == false ? 'border-top-width: ' + options["carousel-indicator-active-border-width"] + 'px !important;' : ''}
          ${options["carousel-indicator-active-border-style"] !== "" && _.isNil(options["carousel-indicator-active-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["carousel-indicator-active-border-width-bottom"] + 'px !important;' : _.isNil(options["carousel-indicator-active-border-width"]) == false ? 'border-bottom-width: ' + options["carousel-indicator-active-border-width"] + 'px !important;' : ''}
          ${options["carousel-indicator-active-border-style"] !== "" && options["carousel-indicator-active-border-color"] ? 'border-color: ' + options["carousel-indicator-active-border-color"] + ' !important;' : options["carousel-indicator-active-color"] ? 'border-color: ' + options["carousel-indicator-active-color"] + ' !important;' : ''}
        }
        `;
      })

    let maxWidthElementMobile = "";
    if (
      options["carousel-max-width-style-mobile"] == "custom" &&
      options["carousel-max-width-value-mobile"]
    ) {
      if (carouselControlsStyle == "outside") {
        maxWidthElementMobile = `${
          parseInt(options["carousel-max-width-value-mobile"]) + 90 // include arrow controls safety space
        }px`;
      } else {
        maxWidthElementMobile = `${options["carousel-max-width-value-mobile"]}px`;
      }
    } else if (options["carousel-max-width-style-mobile"] == "full") {
      maxWidthElementMobile = "100%";
    }

    let maxWidthSlideWrapperMobile = "";
    if (carouselControlsStyle == "outside" && carouselHideArrowControls !== "true") {
      maxWidthSlideWrapperMobile = "75%";
    } else {
      maxWidthSlideWrapperMobile = "100%";
    }

    let carouselHeightMobile;
    if (
      options["carousel-height-style-mobile"] == "custom" &&
      options["carousel-height-value-mobile"]
    ) {
      carouselHeightMobile = `${options["carousel-height-value-mobile"]}px !important`;
    }

    let carouselIndicatorSizeMobile =
      options["carousel-indicator-size-mobile"] || undefined;

    let carouselArrowSizeMobile =
      options["carousel-arrow-size-mobile"] ||
      variant.options["carousel-arrow-size-mobile"];

    // Get mobile preview configuration (for non-builder mode where we output both desktop and mobile styles)
    const mobilePreviewConfig = getPreviewConfig(element, "mobile");
    const { enabled: showPreviewMobile, mainWidth: mainWidthMobile } = mobilePreviewConfig;

    // prettier-ignore
    const mobileStyles =
      `/* mobile styles */
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element {
        ${maxWidthElementMobile ? `max-width: ${maxWidthElementMobile};` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-item {
        ${element.options["carousel-slides-per-view-mobile"]
          ? `flex: 0 0 ${(showPreviewMobile ? mainWidthMobile : 100) / parseInt(element.options["carousel-slides-per-view-mobile"])}% !important;` 
          : `flex: 0 0 ${showPreviewMobile ? mainWidthMobile : 100}% !important;`}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-carousel-item {
        ${carouselHeightMobile ? `height: ${carouselHeightMobile}; min-height: 0px;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-carousel-slide-wrapper {
        ${maxWidthSlideWrapperMobile ? `max-width: ${maxWidthSlideWrapperMobile};` : ''}
        ${showPreviewMobile ? 'overflow: visible;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-carousel-slide-inside-wrapper {
        ${options["carousel-max-width-style-mobile"] == "custom" && options["carousel-max-width-value-mobile"] ? `max-width: ${options["carousel-max-width-value-mobile"]}px;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-arrow-control {
        ${showPreviewMobile ? 'position: relative; z-index: 10;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-carousel-indicator {
        ${carouselIndicatorSizeMobile ? `width: ${carouselIndicatorSizeMobile}px !important;` : ''}
        ${carouselIndicatorSizeMobile ? `height: ${carouselIndicatorSizeMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-carousel-slide-inside-wrapper {
        ${carouselControlsStyle == "inside" && carouselHideArrowControls !== "true" ? carouselArrowSizeMobile > 22 ? `margin: 0px -${((carouselArrowSizeMobile - 22) + 47)}px;` : "margin: 0px -47px;" : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-carousel-element .cf-arrow-control svg {
        ${carouselArrowSizeMobile ? `width: ${parseInt(carouselArrowSizeMobile) + 8}px !important;` : 'width: 20px;'}
        ${carouselArrowSizeMobile ? `height: ${parseInt(carouselArrowSizeMobile) + 8}px !important;` : 'height: 20px;'}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-arrow-control .svg-inline--fa {
        ${carouselArrowSizeMobile ? `font-size: ${carouselArrowSizeMobile}px !important;` : ''}
      }
      `;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
